
{
  "fr": {
    "configuratorQuantitySelect": {
      "label": "Quantité",
      "noQuantity": "Produit indisponible"
    }
  }
}
